import { render, staticRenderFns } from "./01.vue?vue&type=template&id=f3ad4dea"
import script from "./01.vue?vue&type=script&lang=ts"
export * from "./01.vue?vue&type=script&lang=ts"
import style0 from "./01.vue?vue&type=style&index=0&id=f3ad4dea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports